import React, { useState, useEffect } from 'react';
import CouponCard from './CouponCard';
import CouponModal from './CouponModal';
import useEscaneosStore from '../../store/escaneosStore';

const CouponList = () => {
  // Sample coupon data - in a real app, this would come from props or an API
  const { cupones } = useEscaneosStore();
  const [coupons, setCoupons] = useState([
    /* {
      id: 1,
      title: 'Promoción "Restaurante"',
      code: 'BIENVENIDO25',
      type: 'discount',
      value: 15,
      description: '15% de descuento en el total de la cuenta. ',
      expiryDate: '31/12/2025',
      terms: ' Aplica para el socio y hasta 5 acompañantes. No acumulable con otras promociones. '
    },
    {
      id: 2,
      title: 'Promoción "Banquetes"',
      code: 'MARTES20',
      type: 'discount',
      value: 10,
      description: '10% de descuento sobre servicios de Alimentos y Bebidas. ',
      expiryDate: '31/12/2025',
      terms: ' Únicamente para eventos facturados a persona física. No aplica para grupos y convenciones.'
    },
    {
      id: 3,
      title: 'Promoción "Cumpleañero Gratis"',
      code: 'BEBIDAS2X1',
      type: 'promotion',
      value: 'Consumo Gratis',
      description: 'El consumo del cumpleañero es gratuito (desayuno buffet o entrada, plato fuerte, postre y una bebida no alcohólica).',
      expiryDate: '31/12/2025',
      terms: ' Válido durante el mes de su cumpleaños. El socio debe ir acompañado de un mínimo de 4 personas que paguen su consumo. Requiere presentar identificación oficial. '
    },
    {
      id: 4,
      title: 'Promoción "SPA"',
      code: 'MARTES20',
      type: 'discount',
      value: 10,
      description: '10% de descuento.',
      expiryDate: '31/12/2025',
      terms: 'Aplica en masajes y faciales. Requiere reservación previa. '
    },
    {
      id: 5,
      title: 'Promoción "Day Pass con Consumo"',
      code: 'MARTES20',
      type: 'promotion',
      value: '$500 MXN',
      description: ' Se realiza un cobro de $500.00 MXN por persona, y este monto se acredita al 100% para consumos de alimentos y bebidas.',
      expiryDate: '31/12/2025',
      terms: ' No es un descuento porcentual, sino un crédito. El sistema debe registrar el pago y aplicarlo como saldo a favor en el folio del cliente.'
    },
    {
      id: 6,
      title: 'Promoción "Day Pass con Descuento"',
      code: 'MARTES20',
      type: 'promotion',
      value: '200 MXN + 20%',
      description: 'Se realiza un cobro de $200.00 MXN por persona por el derecho de uso de la alberca. Adicionalmente, se aplica un 20% de descuento en consumos de alimentos y bebidas.',
      expiryDate: '31/12/2025',
      terms: 'Se realiza un cobro de $200.00 MXN por persona por el derecho de uso de la alberca. Adicionalmente, se aplica un 20% de descuento en consumos de alimentos y bebidas.'
    },
    {
      id: 7,
      title: 'Promoción "Hospedaje"',
      code: 'MARTES20',
      type: 'discount',
      value: 10,
      description: '10% de descuento sobre la tarifa pública vigente. ',
      expiryDate: '31/12/2025',
      terms: ' Sujeto a disponibilidad y debe ser facturado a persona física.'
    }, */
  ]);

  useEffect(() => {
    setCoupons(cupones);
  }, [cupones])
  

  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCouponClick = (coupon) => {
    setSelectedCoupon(coupon);
    setIsModalOpen(true);
  };

  const handleMarkAsUsed = (validationCode) => {
    if (selectedCoupon) {
      // Here you would typically make an API call to validate the code
      console.log(`Marking coupon ${selectedCoupon.id} as used with code:`, validationCode);
      
      // For demo purposes, we'll just remove the coupon
      setCoupons(coupons.filter(coupon => coupon.id !== selectedCoupon.id));
      setIsModalOpen(false);
      setSelectedCoupon(null);
      
      // In a real app, you might want to show a success message
      // and potentially send the validation code to your backend
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCoupon(null);
  };

  return (
    <div className="mt-4">
      <h4 className="mb-3">Cupones Disponibles</h4>
      
      {coupons.length === 0 ? (
        <div className="alert alert-info">
          No hay cupones disponibles en este momento.
        </div>
      ) : (
        <div className="row">
          {coupons.map((coupon) => (
            <div key={coupon.id} className="col-12 mb-3">
              <CouponCard 
                coupon={coupon} 
                onClick={() => handleCouponClick(coupon)}
              />
            </div>
          ))}
        </div>
      )}

      <CouponModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        coupon={selectedCoupon}
        onMarkAsUsed={handleMarkAsUsed}
      />
    </div>
  );
};

export default CouponList;
